import './ApiCodeToggle.scss';
import { Switch } from 'antd';
import React, { useCallback } from 'react';
export const ApiCodeToggle = ({ checked = false, onChange }) => {
    // Switch onChange passes a second argument that cannot be passed
    // When provided onChange is a setState function.
    const handleOnChange = useCallback((useInternal) => onChange({ useInternal }), [onChange]);
    return (React.createElement(Switch, { checked: checked, checkedChildren: '__C', className: 'api-toggle', onChange: handleOnChange, unCheckedChildren: '__C' }));
};
